<template>
  <!-- 多选多 暂时废弃-->
  <div class="common-panel">
    <div class="panel-content" v-if="isReady">
      <div class="ques-area-des" v-if="descriptionText">{{ serial ? serial + ". " : "" }}{{ descriptionText }}</div>
      <!-- 选项 -->
      <div
        class="panel-content-options"
        :style="{
          flexDirection: directionFlag ? 'row' : 'column',
          alignItems: directionFlag ? 'center' : 'flex-start',
        }"
      >
        <div :class="`question-options-item--${option.type}`" v-for="option in currItemOptions" :key="option.index">
          <div class="item-key">{{ option.key }}</div>
          <div class="item-content" v-if="option.type === 'image'">
            <img :src="option.content" alt="" />
          </div>
          <PhoneticText
            v-else-if="option.type === 'html' || option.type === 'text'"
            :originData="option.content"
            :baseStyles="{
              ...textStyles(option),
              hzFontSize: '16px',
              pinyinFontSize: '12px',
              hzLineHeight: '25px',
            }"
            :showPinyin="option.display != 1"
            :onlyPinyin="option.display == 2"
          ></PhoneticText>
        </div>
      </div>
      <!-- 套题 -->
      <div class="panel-content-details">
        <div class="question-item" v-for="(item, itemIndex) in filterQuestionList" :key="itemIndex">
          <div :class="`question-item--${item.screen_text[0].type}`">
            <div class="question-item-list">
              <div class="stem-index">{{ itemIndex + 1 }}.</div>
              <div class="question-item-stem" v-if="item.screen_text[0].type === 'audio'">
                <div class="stem-content">
                  <img
                    v-show="item.playStatus == 'play' || !item.playStatus"
                    @click="clickPlayVoice(item, itemIndex)"
                    :src="iconPlay('play')"
                    alt=""
                  />
                  <img
                    v-show="item.playStatus == 'pause'"
                    @click="clickPauseVoice(item, itemIndex)"
                    :src="iconPlay('pause')"
                    alt=""
                  />
                </div>
              </div>
              <div
                v-else-if="item.screen_text[0].type === 'html' || item.screen_text[0].type === 'text'"
                class="text_html"
              >
                <PhoneticText
                  :originData="item.screen_text[0].content"
                  :baseStyles="{
                    ...textStyles(item.screen_text[0]),
                    hzFontSize: '16px',
                    pinyinFontSize: '12px',
                    hzLineHeight: '25px',
                  }"
                  :showPinyin="item.screen_text[0].display != 1"
                  :onlyPinyin="item.screen_text[0].display == 2"
                ></PhoneticText>
              </div>
              <div v-else-if="item.screen_text[0].type === 'image'" class="text_img">
                <img :src="item.screen_text[0].content" alt="" />
              </div>
            </div>

            <div class="question-item-options">
              <div
                v-for="option in item.answers"
                :key="`${item.index}_${option.index}`"
                :class="[
                  'question-item-options-item',
                  {
                    selected: option.selected,
                    success: isSubmit && option.correct,
                    error: isSubmit && option.selected && !option.correct,
                  },
                ]"
                :data-correct="option.correct ? 1 : 0"
                @click="clickQuestionChoice($event, item, option)"
              >
                {{ String.fromCharCode(64 + parseInt(option.index)) }}
              </div>
            </div>
          </div>

          <div class="panel-content-result result-correct" v-if="isSubmit && item.isCorrect">
            <p class="correct-tips">
              {{ $t("textbook_chioce_word_text_correct_tip") }}
            </p>
            <!-- <div class="correct-box">
              <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
              <p class="correct-box-answer">
                {{ item.analysisText }}
              </p>
            </div> -->
          </div>

          <div class="panel-content-result result-error" v-if="isSubmit && !item.isCorrect">
            <p class="error-tips">
              {{ $t("textbook_chioce_word_text_error_tip") }}
            </p>
            <div class="result-show">
              <div class="your-answer">{{ $t("hsk_your_answer") }}{{ item.myAnswerText }}</div>
              <p class="correct-answer">{{ $t("hsk_correct_answer") }}{{ item.successAnswerText }}</p>
            </div>
            <!-- <div class="correct-box">
              <p class="correct-box-title">{{ $t('hsk_answer_analysis') }}</p>
              <p class="correct-box-answer">
                {{ item.analysisText }}
              </p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneticText from "@/components/ui/phoneticText";
import { mixinCommon } from "@/mixins";

export default {
  mixins: [mixinCommon],
  components: {
    PhoneticText,
  },
  data() {
    return {
      // 试题列表
      items: [],
      // 当前试题Index
      currIndex: 0,
      // 当前试题正确答案
      currCorrectAnswer: [],
      //我的作答答案
      myAnswer: [],
      // 是否已提交
      isSubmit: false,
      // 是否页面事件禁用
      isDisabled: false,
      icons: {
        play: require("@/assets/images/btn_play_hsk.png"),
        pause: require("@/assets/images/btn_pause_hsk.png"),
      },
      changeBtn: false,
      // 当前题目是否作答正确
      isCorrect: false,
      currItemOptions: [],
      currItem: {},
    };
  },
  computed: {
    filterQuestionList() {
      let questionsList = this.currItem.questions;
      let array = [];
      //去除例题
      array = questionsList.filter(function (item) {
        return !item.is_example;
      });
      //根据当前语言显示分析
      array.map((item, index) => {
        // item.analysisText = item.analysis[this.language]
        if (this.isSubmit && this.myAnswer.length) {
          for (let i = 0; i < item.answers.length; i++) {
            if (item.answers[i].index == this.myAnswer[index]) {
              item.myAnswerText = item.answers[i].flag;
            }
            if (item.answers[i].correct) {
              item.successAnswerText = item.answers[i].flag;
            }
          }
        }
      });
      return array;
    },
    isReady() {
      return !!this.jsonData;
    },
    directionFlag() {
      return this.jsonData.questions[0].answers.some((item) => {
        return item.type === "image";
      });
    },
    language() {
      let local = localStorage.getItem("language");
      return local;
    },
    descriptionText() {
      return this.jsonData.question_description_obj
        ? this.jsonData.question_description_obj[this.language]
          ? this.jsonData.question_description_obj[this.language]
          : this.jsonData.question_description_obj["zh"]
        : "";
    },
  },
  watch: {
    isReady: {
      handler(val) {
        if (val) {
          // 计算选项显示数据
          this.currItem = this.jsonData;
          this.currItemOptions = this.currItem.questions[0].answers.map((item, index) => {
            return {
              index: item.index,
              key: String.fromCharCode(64 + parseInt(item.index)),
              content: item.content,
              type: item.type,
              display: item.display,
            };
          });
        }
      },
      immediate: true,
    },
    jsonData: {
      handler() {
        // 同一题型 切换清空选中状态(初始化数据)
        this.isSubmit = false;
        this.currItem = this.jsonData;
        this.currItem.questions.forEach((item) => {
          if (Object.keys(item).includes("isCorrect")) {
            Object.assign(item, { isCorrect: false });
          }
          if (Object.keys(item).includes("isFinished")) {
            Object.assign(item, { isFinished: false });
          }
          item.answers.forEach((ans) => {
            if (Object.keys(ans).includes("selected")) {
              Object.assign(ans, { selected: false });
            }
          });
        });
        this.currItemOptions = this.currItem.questions[0].answers.map((item, index) => {
          return {
            index: item.index,
            key: String.fromCharCode(64 + parseInt(item.index)),
            content: item.content,
            type: item.type,
          };
        });
        // 如果有音频自动播放第一题
        this.$nextTick(() => {
          if (this.currItem.screen_text[0].type === "audio") {
            this.clickPlayVoice(this.currItem.questions[0]);
          }
        });
        console.log(this.currItem);
      },
    },
  },
  methods: {
    // 小题选项点击事件
    clickQuestionChoice(event, question, option) {
      if (this.isSubmit || this.isDisabled) return;
      event.currentTarget.classList.add("selected");
      this.stopPlayStatus();
      const isCorrect = parseInt(event.currentTarget.dataset.correct) == 1;
      let questions = this.currItem.questions.map((item) => {
        if (item.index === question.index) {
          item.playStatus = "play";
          this.$player.stop();
          //下一题未做过，则自动播放下一题
          if (
            this.returnQuesObj(item.index + 1) &&
            !this.returnQuesObj(item.index + 1).isFinished &&
            question.screen_text[0].type === "audio"
          ) {
            this.clickPlayVoice(this.returnQuesObj(item.index + 1));
          }
          let questionTemp = {
            ...item,
            ansId: option.index, // 学生作答
            isFinished: true, // 标识已作答
            isCorrect, // 标识是否作答成功
          };
          questionTemp.answers = questionTemp.answers.map((item1) => {
            if (item1.index === option.index) {
              return {
                ...item1,
                selected: true,
              };
            } else {
              return {
                ...item1,
                selected: false,
              };
            }
          });

          return questionTemp;
        } else {
          return {
            ...item,
          };
        }
      });

      this.currItem = {
        ...this.currItem,
        questions,
      };

      let flag = this.currItem.questions.find((item) => !item.isFinished && !item.is_example);
      if (!flag) {
        this.$emit("changeIsFinished", true);
      }
    },
    //点击播放
    clickPlayVoice(question) {
      console.log("开始播放");
      this.resetPlayStatus(question, "pause");
      let audioPath = question.screen_text[0].content;
      this.$player.play(audioPath);
      console.log(audioPath);
      this.$player.onended = () => {
        this.resetPlayStatus(question, "play");
      };
    },
    //点击暂停
    clickPauseVoice(question) {
      console.log("暂停");
      this.$player.pause();
      this.resetPlayStatus(question, "play");
    },
    //根据状态显示播放/暂停按钮
    iconPlay(playType) {
      return this.icons[playType];
    },
    //重置播放状态
    resetPlayStatus(question, status) {
      let questions = this.currItem.questions.map((item) => {
        if (item.index === question.index) {
          item.playStatus = status;
          console.log(item.playStatus);
          return item;
        } else {
          item.playStatus = "play";
          return {
            ...item,
          };
        }
      });
      this.currItem.questions = questions;
      console.log(questions);
    },
    //stop所有的icon
    stopPlayStatus() {
      let questions = this.currItem.questions.map((item) => {
        item.playStatus = "play";
        return {
          ...item,
        };
      });
      this.currItem.questions = questions;
    },
    returnQuesObj(index) {
      let quesObj = this.currItem.questions.find((item) => {
        return item.index == index;
      });
      return quesObj;
    },
    // 提交
    handleSubmit() {
      this.isDisabled = true;

      // 解析答案提交
      let answerResult = [];
      this.myAnswer = [];
      let totalScore = 0;
      let isAllCorrect = true;
      this.currItem.questions.forEach((question) => {
        // 全部小题答题正确，才判定
        if (!question.isCorrect && !question.is_example) {
          isAllCorrect = false;
        } else if (!question.is_example) {
          totalScore += 100;
        }
        if (!question.is_example) {
          // 拼装提交
          answerResult.push({
            question_id: question.index,
            answer_result: question.ansId.toString(),
            total_score: question.isCorrect ? question.score : 0,
          });
          this.myAnswer.push(question.ansId);
        }
      });
      //去除例题
      // let array = this.currItem.questions.filter(function (item) {
      //   return !item.is_example
      // })
      // const len = array.length
      // totalScore = parseInt((totalScore / (len * 100)) * 100)

      // 页面反馈答题结果
      this.isCorrect = isAllCorrect;
      let params = {
        answer: JSON.stringify(answerResult),
        questionId: this.jsonData.index,
        scores: totalScore,
      };
      this.$emit("customInterface", params);
      this.$emit("resultScore", totalScore);
      this.isSubmit = true;
      this.isDisabled = false;
      this.$emit("changeIsFinished", false);
      this.$emit("changeIsError", false);
    },
    // 下一题
    // handleNext() {
    //   if (this.currIndex >= this.items.length) {
    //     this.routerToResult()
    //     return
    //   }
    //   this.isCorrect = false
    //   this.isSubmit = false
    //   this.isDisabled = false
    //   this.$emit('changeIsDisabled', false)
    //   this.currIndex++
    //   this.$emit('changeCurrIndex', this.currIndex)
    //   this.$emit('changeIsFinished', false)
    //   this.$emit('changeIsError', false)
    // },
    //停止全部音频，图标都恢复原来的未播放状态
    stopAllVoice() {
      this.currItem.questions.forEach((question) => {
        question.playStatus = "play";
      });
      this.$player.stop();
    },
  },
};
</script>

<style lang="scss" scoped>
.common-panel {
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #b5b5be;
    margin-top: 0px;
  }
  .panel-content {
    min-height: 540px;

    // 选项列表
    &-options {
      padding: 40px 30px 30px 30px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .question-options-item {
        &--image {
          width: 195px;
          height: 110px;
          margin-bottom: 20px;
          margin-right: 40px;
          border-radius: 5px;
          position: relative;

          .item-key {
            width: 46px;
            height: 27px;
            line-height: 27px;
            text-align: center;
            color: #ffffff;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 4px 0px 4px 0px;
            position: absolute;
            top: 0px;
            left: 0px;
          }
          .item-content {
            img {
              width: 195px;
              height: 110px;
              object-fit: contain;
              border-radius: 5px;
            }
          }
        }
        &--html,
        &--text {
          position: relative;
          display: flex;
          justify-content: flex-start;
          padding: 10px 40px;
          min-width: 315px;
          min-height: 50px;
          line-height: 50px;
          font-size: 16px;
          margin-top: 20px;
          color: #3f4651;
          background: #f2f3f7;
          box-sizing: border-box;
          .item-key {
            position: absolute;
            font-size: 16px;
            font-weight: 600;
            color: #aebac6;
            top: 0px;
            left: 16px;
          }
          ::v-deep .phtContent {
            display: flex;
            justify-content: center;
            align-items: center;
            .pht_single {
              text-align: start;
              margin-bottom: 0 !important;
            }
          }
        }
      }
    }

    // 套题详情
    &-details {
      padding: 0 30px;

      .question-item {
        padding: 20px 0;
        border-top: 1px solid #f2f3f7;
        // display: flex;
        &--audio {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        &--html,
        &--text {
          .question-item-options {
            margin-top: 20px;
          }
          .text_html {
            display: flex;
            align-items: center;
            ::v-deep .phtContent {
              display: flex;
              justify-content: center;
              align-items: center;
              .pht_single {
                text-align: start;
                margin-bottom: 0 !important;
              }
            }
          }
        }
        &--image {
          .text_img {
            display: flex;
            align-items: center;
            img {
              width: 195px;
              height: 110px;
              object-fit: contain;
              border-radius: 5px;
              margin-bottom: 20px;
            }
          }
        }
        &-list {
          display: flex;
          align-items: center;
        }
        // .stem-index {
        //   margin-right: 10px;
        //   color: #c4c9d3;
        //   line-height: 17px;
        //   display: flex;
        //   align-items: center;
        // }
        &-stem {
          display: flex;
          flex-direction: row;
          align-items: center;
          .stem-content {
            img {
              width: 40px;
              height: 40px;
              cursor: pointer;
            }
          }
        }
        &-options {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;

          &-item {
            cursor: pointer;
            width: 42px;
            height: 27px;
            line-height: 27px;
            text-align: center;
            background-color: rgba(242, 243, 247, 1);
            border-radius: 2px;
            margin-right: 20px;
            color: rgba(57, 61, 70, 1);
            font-size: 14px;

            &.selected {
              border: 2px solid #faae56;
              background: #ffffff;
            }
            &.success {
              background: #ffffff; // 设置白色背景
              border: 1px solid rgba(9, 203, 160, 1);
              color: #09cba0;
            }
            &.error {
              border: 1px solid #fc5a5a;
              color: #fc5a5a;
              background: #ffffff;
            }
          }
        }
      }
    }

    // 选词填空选项列表
    // &-answers {
    //   margin-top: 30px;
    //   .list-answers {
    //     display: flex;
    //     flex-direction: column;
    //     justify-content: center;
    //     align-items: center;
    //   }

    //   .item-answer {
    //     cursor: pointer;
    //     position: relative;

    //     display: flex;
    //     align-items: center;
    //     justify-content: center;

    //     width: 380px;
    //     height: 58px;
    //     line-height: 58px;
    //     font-size: 18px;
    //     margin-top: 20px;

    //     color: rgba(63, 70, 81, 1);
    //     background: rgba(242, 243, 247, 1);
    //     border-radius: 5px;
    //     box-sizing: border-box;

    //     .text {
    //       overflow: hidden;
    //       text-overflow: ellipsis;

    //       ::v-deep .pht_single {
    //         margin-bottom: 10px !important;
    //       }
    //     }

    //     &:after {
    //       position: absolute;
    //       content: '';
    //       width: 16px;
    //       height: 16px;
    //       right: -24px;
    //       top: 50%;
    //       transform: translateY(-50%);
    //       background-position: 0 0;
    //       background-repeat: no-repeat;
    //       background-size: cover;
    //     }

    //     &.success {
    //       background: #ffffff;   // 设置白色背景
    //       border: 1px solid rgba(9, 203, 160, 1);
    //       color: #09cba0;
    //     }

    //     &.error {
    //       ;
    //       border: 1px solid #FC5A5A;
    //       color: #FC5A5A;
    //     }
    //   }
    // }

    // 结果
    &-result {
      padding-top: 20px;

      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
          // margin-left: 23px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
          // margin-left: 23px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          // margin-left: 23px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 20px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
